import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import { OpenMasterpassCardLinkAction } from './masterpass-card-link-dialog.action';

/* @ngInject */
export default class CardLinkDialogController implements ActionHandler {

  protected approve: () => any;
  public smsCode: string;
  public valid: boolean = true;
  public time: string;
  public isReqSend: boolean;
  protected dialogElement;
  protected dialogOptions;

  protected onSuccess: () => any;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    protected globalSpinner: GlobalSpinnerService
  ) {
    this.actionDispatcher.register(this);
  }

 
  public $postLink() {
    this.dialogElement = this.$element.find('#bank-confirmation').remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenMasterpassCardLinkAction) {
      this.handleDialogAction(action);
    }
  }

  protected handleDialogAction(action: OpenMasterpassCardLinkAction) {
    this.onSuccess = action.onApprove;
    this.openDialog();
  }

  protected onApprove() {
    this.isReqSend = true;
    this.onSuccess();
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
    this.isReqSend = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/buy/masterpass-card-link-dialog/masterpass-card-link-dialog.controller.ts